import SectionHeading from "./SectionHeading";
import certificate1 from "../../Assets/Images/certificate1.png"; 
import certificate2 from "../../Assets/Images/certificate2.png"; 
// Replace with actual path
function AboutAchievements() {
    return (
        <section className="about-achievements pt-0">
            <SectionHeading
                secTitle="Our Achievements"
            />
            <div className="container-fluid">
                <div className="row justify-content-evenly align-items-center pb-4">
                    <div className="col-12 col-lg-5 pb-4">
                        <img src={certificate1} alt="About Us" className="img-fluid" />
                    </div>
                    <div className="col-12 col-lg-5 pb-4">
                        <img src={certificate2} alt="About Us" className="img-fluid" />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AboutAchievements;
